// DataDetailsPage.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import Spinner from '../../util/spinner-shim'
import { useNavigate, useParams } from 'react-router-dom'

import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import DataDetails from '../partials/SettingPageComponents/DataDetailsComponents/DataDetails'
import withAppStore from '../../util/withAppStore'

import AppStore from '../../stores/AppStore'
import styles from '../../../css/home.module.css'
import GridList from '../partials/GridList'
import AppDispatcher from '../../dispatchers/AppDispatcher'

const dispatch = (action, obj = {}) => AppDispatcher.dispatch({ action, ...obj })

function DataDetailsPage (props) {
  const navigate = useNavigate()
  const { deviceID, customerID } = useParams()

  const goTo = React.useCallback((x) => navigate(x), [navigate])
  const goBack = React.useCallback(() => {
    goTo(`/${customerID}/devices/${deviceID}`)
  }, [customerID, deviceID, goTo])
  const getNewData = React.useCallback(() => {
    dispatch('get-device', { deviceID })
  }, [deviceID])

  React.useEffect(() => {
    getNewData()
  }, [getNewData])

  const {
    auth: {
      logout,
    },
    auth,
    route: {
      path,
    },
    intl: {
      formatMessage,
    },
    data,
    data: {
      lookupReady,
      lookup,
    } = {},
  } = props
  const device = lookupReady && lookup[deviceID]
  const devices = [device]

  const { id: customerIDFromStore } = AppStore.getCustomer()
  const tileInfo = 'default'

  const DATA_DETAILS = formatMessage({
    id: 'customer.dataDetails',
    defaultMessage: 'Data Details',
    description: 'Data Details label',
  })

  const subject = device
    ? (
      <div className={styles.pageWidth}>
        <div>
          <DataDetails
            user={AppStore.getUser()}
            devices={device}
            auth={auth}
            data={data}
            params={{ deviceID, customerID }}
            customerID={customerIDFromStore}
            nextPage={goTo}
          />
        </div>
      </div>
      )
    : (
      <div className='loading'>
        <Spinner name='double-bounce' />
      </div>
      )

  return (
    <div>
      <Helmet><title>{DATA_DETAILS}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        page={path}
        name={DATA_DETAILS}
        logOut={() => logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div>
          <div className={styles.pageContainer}>
            <section>
              <GridList devices={devices} selectMode={false} tileInfo={tileInfo} />
              {subject}
            </section>
            <br />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

DataDetailsPage.propTypes = {
  auth: PropTypes.object,
  route: PropTypes.object,
  intl: PropTypes.object,
  data: PropTypes.object,
}

export default withAppStore(injectIntl(DataDetailsPage))
